import { render, staticRenderFns } from "./MitActionNewPersonContinuePage.vue?vue&type=template&id=4a673cf5&scoped=true"
import script from "./MitActionNewPersonContinuePage.vue?vue&type=script&lang=js"
export * from "./MitActionNewPersonContinuePage.vue?vue&type=script&lang=js"
import style0 from "./MitActionNewPersonContinuePage.vue?vue&type=style&index=0&id=4a673cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a673cf5",
  null
  
)

export default component.exports